import { computed, makeAutoObservable } from "mobx";
// import { utils } from '@intrasync/utils';
import type RootStore from "../RootStore";
import { ScheduleGridColumnHeader } from "types/ScheduleGridTypes";
// import { databaseDate } from '@intrasync/utils';
import { utils } from "@intrasync/utils";

// interface SortState {
//   sortBy: string[];
//   sortDirection: Record<string, string>;
// }

interface CellHover {
  columnIndex?: number;
  rowIndex?: number;
}

// interface SortConfig {
//   sortKey: string;
//   sortKeyType: string;
//   sortDirection: string;
// }

// interface DataItem {
//   [key: string]: string | number | boolean | null;
// }

class ScheduleGridStoreNamespace {
  rootStore: RootStore;
  namespace: string;
  currentStoreName = "";
  uniqueKey = "id";
  entityValue = "entities";
  dateKey = "date";
  columnHeaders: ScheduleGridColumnHeader[] = [];
  // sortState: SortState = { sortBy: [], sortDirection: {} };
  // filterState: Record<string, string> = {};
  // editData: Record<
  //   string | number,
  //   Record<string | number, string | number | boolean | null>
  // > = {};
  currentCellHover: CellHover = { columnIndex: undefined, rowIndex: undefined };
  // fullGridEditMode = false;
  // removeColumnEnabled = false;
  // removeItemColumnHeader: ScheduleGridColumnHeader = {
  //   key: 'remove',
  //   title: 'Remove',
  //   width: 60,
  // };
  schedulerRef: { recomputeGridSize: () => void } | null = null;

  constructor(rootStore: RootStore, namespace: string) {
    makeAutoObservable(this, { rootStore: false });
    this.rootStore = rootStore;
    this.namespace = namespace;

    // reaction(
    //   () => this.columnHeaders,
    //   (columnHeaders) => {
    //     console.log('columnHeaders', columnHeaders);
    //   },
    //   { fireImmediately: true }
    // );
  }

  setUniqueKey = (value: string) => {
    this.uniqueKey = value;
  };

  setCurrentStoreName = (storeName: string) => {
    this.currentStoreName = storeName;
  };

  setDateKey = (dateKey: string) => {
    this.dateKey = dateKey;
  };

  setSchedulerRef = (
    newSchedulerRef: { recomputeGridSize: () => void } | null
  ) => {
    this.schedulerRef = newSchedulerRef;
  };

  recomputeScheduler = () => {
    this.schedulerRef?.recomputeGridSize();
  };

  // setFullGridEditMode = () => {
  //   this.fullGridEditMode = !this.fullGridEditMode;
  //   if (!this.fullGridEditMode && Object.keys(this.editData).length > 0) {
  //     this.resetEditData();
  //   }
  // };

  // toggleRemoveColumn = () => {
  //   this.removeColumnEnabled = !this.removeColumnEnabled;
  //   this.recomputeScheduler();
  // };

  // setEditData = (key: string | number, data: object) => {
  //   this.editData[key] = { ...this.editData[key], ...data };
  // };

  // removeEditData = (key: string | number, dataKey?: string | number) => {
  //   if (key && !dataKey) {
  //     delete this.editData[key];
  //   } else if (this.editData[key] && dataKey !== undefined) {
  //     delete this.editData[key][dataKey];
  //   }
  // };

  // setDefaultSort = (defaultSort: SortState) => {
  //   this.sortState = { ...defaultSort };
  // };

  // setDefaultFilter = (defaultFilter: Record<string, string>) => {
  //   this.filterState = { ...defaultFilter };
  // };

  setColumnHeaders = (newColumnHeaders: ScheduleGridColumnHeader[]) => {
    const headersWereAlreadySet = this.columnHeaders.length > 0;
    this.columnHeaders = newColumnHeaders;
    if (headersWereAlreadySet) {
      this.recomputeScheduler();
    }
  };

  setEntityValue = (newEntitiesValue: string) => {
    this.entityValue = newEntitiesValue;
  };

  setCurrentCellHover = (columnIndex: number, rowIndex: number) => {
    this.currentCellHover = { columnIndex, rowIndex };
  };

  resetCellHover = () => {
    this.currentCellHover = { columnIndex: undefined, rowIndex: undefined };
  };

  // setFilter = (columnKey: string | number, filterValue: string) => {
  //   if (filterValue === '') {
  //     delete this.filterState[columnKey];
  //   } else {
  //     this.filterState[columnKey] = filterValue;
  //   }
  // };

  // handleMultiSort = ({
  //   sortBy,
  //   sortDirection,
  // }: {
  //   sortBy: string;
  //   sortDirection: string;
  // }) => {
  //   if (this.sortState.sortBy.includes(sortBy)) {
  //     runInAction(() => {
  //       this.sortState.sortDirection[sortBy] = sortDirection;
  //     });
  //   } else if (this.sortState.sortBy.length < 4) {
  //     runInAction(() => {
  //       this.sortState.sortBy.push(sortBy);
  //       this.sortState.sortDirection[sortBy] = sortDirection;
  //     });
  //   } else {
  //     console.warn('Needs to implement something');
  //   }
  // };

  // removeSortBy = (sortBy: string) => {
  //   runInAction(() => {
  //     this.sortState.sortBy = this.sortState.sortBy.filter(
  //       (sorted) => sorted !== sortBy
  //     );
  //     delete this.sortState.sortDirection[sortBy];
  //   });
  // };

  addColumnHeader = (newHeader: ScheduleGridColumnHeader, index?: number) => {
    if (index === undefined) {
      this.columnHeaders.push(newHeader);
    } else {
      this.columnHeaders.splice(index, 0, newHeader);
    }
    this.recomputeScheduler();
  };

  removeColumnHeader = (headerKey?: string, index?: number) => {
    if (headerKey) {
      this.columnHeaders = this.columnHeaders.filter(
        (c) => c.key !== headerKey
      );
    } else if (index !== undefined) {
      this.columnHeaders.splice(index, 1);
    } else {
      this.columnHeaders.pop();
    }
    this.recomputeScheduler();
  };

  updateColumnHeader = (
    headerKeyOrIndex: number | string,
    newHeader: ScheduleGridColumnHeader
  ) => {
    let index: number;
    if (typeof headerKeyOrIndex === "string") {
      index = this.columnHeaders.findIndex((c) => c.key === headerKeyOrIndex);
    } else {
      index = headerKeyOrIndex;
    }
    if (index >= 0 && index < this.columnHeaders.length) {
      this.columnHeaders[index] = {
        ...this.columnHeaders[index],
        ...newHeader,
      };
      this.recomputeScheduler();
    } else {
      console.warn("No header found with key or index", headerKeyOrIndex);
    }
  };

  setScheduler = ({
    currentStoreName,
    columnHeaders,
  }: // sortState,
  // filterState,
  {
    currentStoreName: string;
    columnHeaders: ScheduleGridColumnHeader[];
    // sortState?: SortState;
    // filterState?: Record<string, string>;
  }) => {
    this.setCurrentStoreName(currentStoreName);
    this.setColumnHeaders(columnHeaders);
    // if (sortState) {
    //   this.setDefaultSort(sortState);
    // }
    // if (filterState) {
    //   this.setDefaultFilter(filterState);
    // }
  };

  // resetEditData = () => {
  //   this.editData = {};
  // };

  resetScheduler = () => {
    //   this.currentStoreName = '';
    this.uniqueKey = "id";
    //   this.fullGridEditMode = false;
    // if (this.removeColumnEnabled) {
    //   this.toggleRemoveColumn();
    // }
    // this.removeColumnEnabled = false;
    this.columnHeaders = [];
    //   this.sortState = { sortBy: [], sortDirection: {} };
    //   this.filterState = {};
    this.currentCellHover = { columnIndex: undefined, rowIndex: undefined };
    this.setEntityValue("entities");
    //   this.resetEditData();
    this.schedulerRef = null;
  };

  get currentStore() {
    return this.rootStore[this.currentStoreName] as Record<string, unknown>;
  }

  get currentStoreEntities() {
    if (!this.currentStore || !this.currentStore[this.entityValue]) return [];
    return (
      [...(this.currentStore[this.entityValue] as object[])]
        .slice()
        .map((i: object) => ({ ...i })) || []
    );
  }

  get currentStoreHeaders() {
    if (!this.currentStore || !this.currentStore.columnHeaders) return [];
    return (
      [...(this.currentStore.columnHeaders as object[])]
        .slice()
        .map((i: object) => ({ ...i })) || []
    );
  }

  get currentStoreDateRange() {
    if (!this.currentStore || !this.currentStore.dateKey) return [];
    // console.log('this.currentStore.dateKey', this.currentStore.dateKey);
    return (
      [...(this.currentStore.dateKey as object[])]
        .slice()
        .map((i: object) => ({ ...i })) || []
    );
  }

  get currentData() {
    const data = this.currentStoreEntities;
    if (!data.length) return [];

    // console.log('data', data);

    // if (this.dateKey) {
    //   console.log('this.dateKey', this.dateKey);
    // }
    // console.log('this.currentStore.dateRange', this.currentStore.dateRange);

    const dateKey = this.dateKey;
    // console.log('dateKey', dateKey);

    const dataByDate = utils.groupBy(data, dateKey as string);
    // console.log('dataByDate', dataByDate);
    // const dateValues = data.map((i: { [key: string]: unknown }) =>
    //   databaseDate(i[dateKey] as string)
    // );
    // const uniqueDates = [...new Set(dateValues)];
    // console.log('uniqueDates', uniqueDates);
    // const sortedDates = uniqueDates.sort();
    // console.log('sortedDates', sortedDates);

    // const columnKeys = this.currentColumnKeys.slice(1);
    // console.log('columnKeys', columnKeys);

    const dateRowData = (this.currentStore.dateRange as string[]).map(
      (date) => {
        if (date in dataByDate) {
          // console.log('date in dataByDate', date);

          const dateData = computed(() => dataByDate[date]).get();
          // console.log('dateData', dateData);
          return {
            schedulerDate: date,
            entities: dateData,
          };
        }
        return {
          schedulerDate: date,
          entities: [],
        };
      }
    );
    // console.log('dateRowData', dateRowData);

    return dateRowData;

    // const filteredData = data.filter((i: object) => {
    // const filterKeys = Object.keys(this.filterState);
    // if (!filterKeys.length) return true;

    // return Object.entries(i)
    //   // .filter(([key]) => this.filterState[key])
    //   .every(([key, value]) => {
    //     // const currentFilterValue = this.filterState[key];
    //     if (currentFilterValue === '*') return !!value;
    //     if (currentFilterValue === '!') return !value;
    //     if (currentFilterValue.startsWith('!'))
    //       return !String(value)
    //         .toLowerCase()
    //         .includes(currentFilterValue.slice(1).toLowerCase());
    //     return String(value)
    //       .toLowerCase()
    //       .includes(currentFilterValue.toLowerCase());
    //   });
    //   return i;
    // });

    // const booleanFormattedData = filteredData.map((i: object) => {
    //   const boolKeys = Object.entries(i).reduce<string[]>(
    //     (acc, [key, value]) => {
    //       const foundHeaderType = this.currentColumnHeaders.find(
    //         (header: ScheduleGridColumnHeader) =>
    //           header.key === key && header.dataType
    //       );
    //       if (
    //         foundHeaderType?.dataType === 'boolean' ||
    //         typeof value === 'boolean'
    //       ) {
    //         acc.push(key);
    //       }
    //       return acc;
    //     },
    //     []
    //   );

    //   if (boolKeys.length) {
    //     const returnItem: { [key: string]: string | number | boolean | null } =
    //       { ...i };
    //     boolKeys.forEach((key) => {
    //       returnItem[key] = returnItem[key] ? 'True' : 'False';
    //     });
    //     return returnItem;
    //   }
    //   return i;
    // });

    // if (this.sortState.sortBy.length && booleanFormattedData.length) {
    //   const dataTypes = this.sortState.sortBy.map((sortKey) => {
    //     const foundHeaderType = this.currentColumnHeaders.find(
    //       (header) => header.key === sortKey && header.dataType
    //     );
    //     const sortKeyType =
    //       foundHeaderType?.dataType ||
    //       (typeof booleanFormattedData[0][sortKey] === 'string'
    //         ? 'date'
    //         : typeof booleanFormattedData[0][sortKey]);
    //     return {
    //       sortKey,
    //       sortKeyType,
    //       sortDirection: this.sortState.sortDirection[sortKey],
    //     };
    //   });

    //   const sortFunc = (a: DataItem, b: DataItem, currentSort: SortConfig) => {
    //     if (currentSort.sortKeyType === 'number') {
    //       const valueA = (a[currentSort.sortKey] ?? 0) as number;
    //       const valueB = (b[currentSort.sortKey] ?? 0) as number;
    //       return currentSort.sortDirection === 'DESC'
    //         ? valueB - valueA
    //         : valueA - valueB;
    //     }
    //     if (
    //       currentSort.sortKeyType === 'string' ||
    //       currentSort.sortKeyType === 'date' ||
    //       currentSort.sortKeyType === 'time'
    //     ) {
    //       const valueA = String(a[currentSort.sortKey] || '');
    //       const valueB = String(b[currentSort.sortKey] || '');
    //       return currentSort.sortDirection === 'DESC'
    //         ? valueB.localeCompare(valueA)
    //         : valueA.localeCompare(valueB);
    //     }
    //     return currentSort.sortDirection === 'DESC'
    //       ? `${b[currentSort.sortKey]}`.localeCompare(
    //           `${a[currentSort.sortKey]}`
    //         )
    //       : `${a[currentSort.sortKey]}`.localeCompare(
    //           `${b[currentSort.sortKey]}`
    //         );
    //   };

    //   const recursiveSort = (
    //     currentData: DataItem[],
    //     currentSort: SortConfig
    //   ) => currentData.sort((a, b) => sortFunc(a, b, currentSort));

    //   const processGroupBy = (
    //     sortedArray: DataItem[],
    //     currentSort: SortConfig
    //   ) => {
    //     const sortKey = currentSort.sortKey;
    //     if (currentSort.sortKeyType === 'number') {
    //       const numberSorted = sortedArray.map((i) => ({
    //         ...i,
    //         [sortKey]: `number-${i[sortKey]}`,
    //       }));
    //       const groupedFirstNumberSort = utils.utils.groupBy(numberSorted, sortKey);
    //       return Object.values(groupedFirstNumberSort).map((currentArray) =>
    //         currentArray.map((i) => ({
    //           ...i,
    //           [sortKey]: `${i[sortKey]}`.replace('number-', ''),
    //         }))
    //       );
    //     }
    //     const groupedFirstSort = utils.utils.groupBy(sortedArray, sortKey);
    //     return Object.values(groupedFirstSort);
    //   };

    //   const sortedRows = dataTypes
    //     .reduce<DataItem[][]>((acc, currentSort, index) => {
    //       if (!acc.length) {
    //         const firstSort = recursiveSort(booleanFormattedData, currentSort);
    //         return processGroupBy(firstSort, currentSort);
    //       }

    //       let result: DataItem[][] = [];

    //       if (index === 1) {
    //         result = acc.flatMap((currentSortArray) =>
    //           processGroupBy(
    //             recursiveSort(currentSortArray, currentSort),
    //             currentSort
    //           )
    //         );
    //       } else if (index === 2) {
    //         result = acc.flatMap((currentSortArray) =>
    //           processGroupBy(
    //             recursiveSort(currentSortArray, currentSort),
    //             currentSort
    //           )
    //         );
    //       } else if (index === 3) {
    //         result = acc.flatMap((currentSortArray) =>
    //           processGroupBy(
    //             recursiveSort(currentSortArray, currentSort),
    //             currentSort
    //           )
    //         );
    //       } else {
    //         result = acc;
    //       }

    //       return result;
    //     }, [])
    //     .flat(Infinity);

    //   return sortedRows;
    // }

    // return booleanFormattedData;
  }

  get currentRows() {
    // console.log('this.currentData', this.currentData);
    const currentData = this.currentData;
    // console.log('currentRows currentData', currentData);
    return [
      { header: "headerRow" },
      // { filter: 'filterRow' },
      ...currentData,
    ];
  }

  get currentColumnHeaders() {
    if (
      (
        this.rootStore[this.currentStoreName] as {
          columnHeaders?: ScheduleGridColumnHeader[];
        }
      )?.columnHeaders
    ) {
      return (
        this.rootStore[this.currentStoreName] as {
          columnHeaders?: ScheduleGridColumnHeader[];
        }
      )?.columnHeaders;
    }
    if (this.columnHeaders.length) {
      // console.log('this.columnHeaders', this.columnHeaders);
      // return this.removeColumnEnabled
      //   ? [this.removeItemColumnHeader, ...this.columnHeaders]
      //   : this.columnHeaders;
      return this.columnHeaders;
    }
    // if (this.currentStoreEntities.length) {
    //   const automaticHeaders = Object.keys(this.currentStoreEntities[0])
    //     .sort()
    //     .map((headerKey) => ({
    //       key: headerKey,
    //       title: utils.camelToTitle(headerKey),
    //       dataType: undefined,
    //     }));
    //   // return this.removeColumnEnabled
    //   //   ? [this.removeItemColumnHeader, ...automaticHeaders]
    //   //   : automaticHeaders;
    //   return automaticHeaders;
    // }
    // return this.removeColumnEnabled
    //   ? [this.removeItemColumnHeader, { key: 'id', title: 'Id' }]
    //   : [{ key: 'id', title: 'Id' }];
    return [{ key: "id", title: "Id" }];
  }

  get currentColumnKeys() {
    return this.currentColumnHeaders?.map((column) => column.key) ?? [];
  }
}

export default ScheduleGridStoreNamespace;
